import { loadCldr, setCulture, setCurrencyCode } from '@syncfusion/ej2-base';
import axios from 'axios';

const EJ2Plugin = {
    cldrDataBaseUrl: null,
    defaultCultureName: 'en-AU',
    defaultCurrencyCode: 'AUD',
    loadedCldrData: [],
    ej2SetCultureAndCurrency: function (cultureName, currencyCode) {
        if ((typeof (cultureName) === 'undefined') || (cultureName == null)) {
            cultureName = this.defaultCultureName;
        }
        if ((typeof (currencyCode) === 'undefined') || (currencyCode == null)) {
            currencyCode = this.defaultCurrencyCode;
        }
        this.loadCldrData(cultureName)
            .then(() => {
                setCulture(cultureName);
                setCurrencyCode(currencyCode);
            });
    },

    loadCldrData: function (cultureName) {
        var promises = [];
        var loadingSupplemental = false;
        if (this.loadedCldrData.indexOf('supplemental') < 0) {
            promises.push(this.loadCldrDataFile('numberingSystems.json'));
            promises.push(this.loadCldrDataFile('weekData.json'));
            loadingSupplemental = true;
        }
        var loadingCulture = false;
        if (this.loadedCldrData.indexOf(cultureName) < 0) {
            promises.push(this.loadCldrDataFile('ca-generic.json', cultureName));
            promises.push(this.loadCldrDataFile('ca-gregorian.json', cultureName));
            promises.push(this.loadCldrDataFile('currencies.json', cultureName));
            promises.push(this.loadCldrDataFile('numbers.json', cultureName));
            promises.push(this.loadCldrDataFile('timeZoneNames.json', cultureName));
            loadingCulture = true;
            
        }
        if (promises.length > 0) {
            return Promise.all(promises)
                .then(() => {
                    if (loadingSupplemental) this.loadedCldrData.push('supplemental');
                    if (loadingCulture) this.loadedCldrData.push(cultureName);
                });
        }
        return Promise.resolve();
    },
    loadCldrDataFile: function (fileName, cultureName) {
        var url = this.cldrDataBaseUrl;
        if (!url.endsWith('/')) url += '/';
        if (cultureName) {
            url += 'main/';
            url += cultureName;
            url += '/';
        } else {
            url += 'supplemental/';
        }
        url += fileName;
        return axios
            .get(url)
            .then(response => {
                loadCldr(response.data);
            });
    },

    install(Vue, options) {
        this.cldrDataBaseUrl = options.cldrDataBaseUrl;
        if ((typeof (options.defaultCultureName) !== 'undefined') && (options.defaultCultureName != null)) {
            this.defaultCultureName = options.defaultCultureName;
        } else if ((typeof (Vue.prototype.$config) !== 'undefined') && (Vue.prototype.$config != null) && (typeof (Vue.prototype.$config.currentLocale) !== 'undefined') && (Vue.prototype.$config.currentLocale != null)) {
            this.defaultCultureName = Vue.prototype.$config.currentLocale;
        }
        if ((typeof (options.defaultCurrencyCode) !== 'undefined') && (options.defaultCurrencyCode != null)) {
            this.defaultCurrencyCode = options.defaultCurrencyCode;
        } else if ((typeof (Vue.prototype.$config) !== 'undefined') && (Vue.prototype.$config != null) && (typeof (Vue.prototype.$config.defaultCurrencyCode) !== 'undefined') && (Vue.prototype.$config.defaultCurrencyCode != null)) {
            this.defaultCurrencyCode = Vue.prototype.$config.defaultCurrencyCode;
        }
        Vue.prototype.$ej2 = EJ2Plugin;
        this.ej2SetCultureAndCurrency();
    }
};

export default EJ2Plugin;